const LabelConversion = (unit: any) => {
    if (unit === 'tbsp') {
        return { label: 'Large Spoon(s)', value: unit }
    }
    if (unit === 'tsp') {
        return { label: 'Medium Spoon(s)', value: unit }
    }
    if (unit === 'g') {
        return { label: 'gram(s)', value: unit }
    }
    return { label: unit, value: unit }

}
export default LabelConversion;